import {NavTheme} from 'epic-games-nav/dist/client';

export const getNavTheme = (): NavTheme => {
    const palette = {
        text: {
            primary: '#ccc',
            primaryHover: '#fff'
        },
        background: {
            default: '#2a2a2a',
            paper: '#1f1f1f'
        },
        border: '#2a2a2a',
        accent: {
            text: '#0078f2',
            background: '#0078f2',
            backgroundText: '#fff',
            backgroundHover: '#007dfc'
        }
    };

    return {
        logo: {
            src: 'https://cdn2.unrealengine.com/epicdev-logo-c1f6fcaae232.svg?resize=1&w=100&quality=high',
            margin: '0 12px 0 12px',
            width: 36
        },
        forwardIcon: 'arrow-forward',
        palette,
        fonts: {
            default: 'Inter, OpenSans, sans-serif, arial',
            heading2: 'Inter, OpenSans, sans-serif, arial',
            heading3: 'Inter, OpenSans, sans-serif, arial',
            heading4: 'Inter, OpenSans, sans-serif, arial',
            paragraph: 'Inter, OpenSans, sans-serif, arial'
        }
    };
};

export const useNavTheme = (): NavTheme => {
    const navTheme = getNavTheme();

    // don't modify the original object, use a clone
    const theme: NavTheme = {
        ...navTheme,
        logo: {
            ...navTheme.logo
        },
        palette: {
            ...navTheme.palette
        }
    };

    return theme;
};
